import * as React from "react";

import { Spin } from "antd";

import { assertNever } from "../utils/obj";

export class DeferredContent<T> extends React.PureComponent<
    DeferredContentProps<T>,
    DeferredContentState<T>
> {
    state: DeferredContentState<T> = { type: "FIRST_LOAD", promiseId: 0 };

    constructor(props: DeferredContentProps<T>) {
        super(props);

        const promiseId = this.state.promiseId;
        this.props.promise.then((value) => {
            if (this.state.promiseId === promiseId) {
                this.setState({ type: "LOADED", value, promiseId });
            }
        });
    }

    componentDidUpdate(prevProps: Readonly<DeferredContentProps<T>>) {
        if (this.props.promise !== prevProps.promise) {
            const promiseId = this.state.promiseId + 1;
            if (this.state.type === "LOADED") {
                this.setState({
                    type: "RELOAD",
                    value: this.state.value,
                    promiseId,
                });
            } else {
                this.setState({ promiseId });
            }
            this.props.promise.then((value) => {
                if (this.state.promiseId === promiseId) {
                    this.setState({ type: "LOADED", value, promiseId });
                }
            });
        }
    }

    render() {
        const { renderContent, showSpinner } = this.props;

        switch (this.state.type) {
            case "FIRST_LOAD":
                return null;
            case "LOADED":
            case "RELOAD":
                return (
                    <Spin
                        spinning={
                            showSpinner === true && this.state.type === "RELOAD"
                        }
                    >
                        {renderContent(this.state.value)}
                    </Spin>
                );
            default:
                assertNever(this.state);
        }
    }
}

interface DeferredContentProps<T> {
    promise: Promise<T>;
    renderContent: (value: T) => React.ReactNode;
    showSpinner?: boolean;
}

type PromiseState<T> =
    | { type: "FIRST_LOAD" }
    | { type: "LOADED"; value: T }
    | { type: "RELOAD"; value: T };

interface CommonState {
    promiseId: number;
}

type DeferredContentState<T> = PromiseState<T> & CommonState;
